import React from "react";

export default function Title({ title }) {
    return (
        <p className="ts-title">{title}</p>
    
    )
}
